import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { count } from 'rxjs/operators';
import { DataDirectoryService } from '../data-directory/data-directory.service';
import { HomeService } from '../home/home.services';
import { BusinessCaseComponent } from './business-case/business-case.component';
import { SettingsService } from './settings.service';
import { ActivatedRoute } from "@angular/router";
import { environment } from 'src/environments/environment.prod';

//parent
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  apiData: [];
  name = 'Next';
  enableRegTab = false;
  enableBeStudyTab = false;
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  searchValue = '';
  DragData: any = {};
  noData = false;
  apiCost: any;
  needRefresh: boolean; // to refresh child[investment-costig] api 
  clearData: boolean = true;
  paramsValues: any;

  constructor(private service: SettingsService, private homeservice: HomeService, private directoryservice: DataDirectoryService, private route: ActivatedRoute,) {
    this.submolecules = [];
    this.directoryservice.serchKey = '';
  }

  @ViewChild('childComponent', { static: false })
  childComponent: any = BusinessCaseComponent;
  anyMethod(): void {
    this.childComponent.getAllApis()
  }

  ngOnInit(): void {
    this.paramsValues = this.route.snapshot.queryParams;
    if (this.paramsValues.brand_name && this.paramsValues.nda && this.paramsValues.dosage) {
      this.searchValue = this.paramsValues.brand_name
      this.searchMolecule()
      // this.selectedSubMolecule = { code: 'WAKIX,211150,TABLET', name: 'WAKIX,211150,TABLET' }
      this.selectedSubMolecule = { code: (`${this.paramsValues.brand_name},${this.paramsValues.nda},${this.paramsValues.dosage}`), name: (`${this.paramsValues.brand_name},${this.paramsValues.nda},${this.paramsValues.dosage}`) }
      this.getData()
    }
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = '';
    this.subMolecule = false;
    this.clearData = false;
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule() {
    this.submolecules = [];
    this.homeservice.getNdaData(this.searchValue).subscribe((ndaValues) => {
      if (ndaValues['data'].nda_numbers.length >= 1) {
        let dropdownvalues = this.arrayToDropdown(ndaValues['data'].nda_numbers);
        this.submolecules = dropdownvalues;
        this.subMolecule = true;
        this.Molecule = false;
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
      }
    })
  }

  getData() {
    if (this.selectedSubMolecule !== undefined) {
      let ndaValue = this.selectedSubMolecule['code'];
      this.needRefresh = false;
      this.homeservice.getDrugData(ndaValue).subscribe((MoleculeData: any) => {
        if (MoleculeData !== null) {
          this.apiCost = MoleculeData
          this.Molecule = true;
          this.DragData = MoleculeData;
          this.noData = false;
          this.needRefresh = true;
          this.clearData = true;

        } else {
          this.noData = true;
          this.Molecule = false;
          this.DragData = {};
        }
      })
    }
  }

  openBusinessCaseStatusDashboard() {
    const url = `${environment.ip}#/businesscase-status-dashboard`;
    window.open(url, '_blank');
  }


}
